;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.view
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::current-route
 (fn [db]
   (get db :current-route)))

(defmulti view-display :name)

(defmethod view-display :default
  [_]
  [:div])

(defn main
  []
  (let [current-route (rf/subscribe [::current-route])]
    (fn []
      (when-let [{:keys [data parameters]} @current-route]
        [:<>
         ^{:key (:name data)}
         [view-display
          {:name (:name data)
           :parameters parameters}]]))))
